import { Box, Button, Typography } from '@mui/material'
import { useContext } from 'react'
import { Link } from 'react-router-dom'

import { EthBlock } from '../../../Components'
import { AppSettingsContext, StatsContext, useMinter } from '../../../Contexts'

const Header: React.FC = () => {
  const { developerMode } = useContext(AppSettingsContext)
  const { minter } = useMinter()
  const { update, refresh } = useContext(StatsContext)

  const onUpdate = () => {
    update?.()
  }

  const onRefresh = () => {
    refresh?.()
  }

  return (
    <Box alignItems="center" display="flex" flexDirection="row" justifyContent="space-between" padding={2}>
      <Box display="flex">
        <Typography variant="caption">As of block</Typography>
        <EthBlock block={minter?.blockNumber ? minter?.blockNumber - 1 : undefined} />
      </Box>
      <Box display="flex">
        <Box display="flex" justifyContent="center" margin={0.5}>
          <Button onClick={onUpdate} variant="contained">
            Update
          </Button>
        </Box>
        <Box display="flex" justifyContent="center" margin={0.5}>
          <Button onClick={onRefresh} variant="contained">
            Refresh
          </Button>
        </Box>
        <Box display={developerMode ? 'flex' : 'none'} justifyContent="center" margin={0.5}>
          <Button component={Link} to={'/stats/json'} variant="outlined">
            Json
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Header
